module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-video-block clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "index-title-block clearfix"
  }, [_c('div', {
    staticClass: "pull-left index-title"
  }, [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === _vm.Type.COURSE),
      expression: "this.type === Type.COURSE"
    }]
  }, [_vm._v("课程视频")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === _vm.Type.LECTURE),
      expression: "this.type === Type.LECTURE"
    }]
  }, [_vm._v("其他视频")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right index-title-more"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === _vm.Type.COURSE),
      expression: "this.type === Type.COURSE"
    }],
    staticClass: "nb-a",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/' + _vm.topic.location + '/resource/video')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t更多\n\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-caret-square-o-right color-main"
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.type === _vm.Type.LECTURE),
      expression: "this.type === Type.LECTURE"
    }],
    staticClass: "nb-a",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.$router.push('/' + _vm.topic.location + '/resource/lecture')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t更多\n\t\t\t\t\t\t\t"), _c('i', {
    staticClass: "fa fa-caret-square-o-right color-main"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "index-content-block"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.pager.videos), function(video) {
    return _c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "img-block",
      style: ('background-image:url(' + video.poster.url + ')'),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return video.click()
        }
      }
    }, [_c('i', {
      staticClass: "ml10 mt10 fa fa-play-circle-o white f30"
    })])])
  }), 0)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-bea7c3c6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/lobby/view/scenery/index/widget/IndexVideo.vue
// module id = 1020
// module chunks = 1